import { render, staticRenderFns } from "./publishRFCNum.vue?vue&type=template&id=0c56885e&scoped=true&"
import script from "./publishRFCNum.vue?vue&type=script&lang=js&"
export * from "./publishRFCNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c56885e",
  null
  
)

export default component.exports